import React from "react";
import Box from "@material-ui/core/Box";
import {makeStyles} from "@material-ui/styles";
import CalculatorTileLabel from "./CalculatorTileLabel";

const useStyles = makeStyles(theme => ({
    paper: {
        padding: '10px',
        minHeight: '100px'
    },
}));

const CalculatorTile = (props) => {
    const styles = useStyles();

    return (
        <div>
            <Box border={1} borderColor="grey.400">
                <div className={styles.paper}>
                    <CalculatorTileLabel name={props.name}/>
                </div>
            </Box>
        </div>
    )
};

export default CalculatorTile;